export enum AchievementStatus {
  FAILED = 'FAILED',
  HIDDEN = 'HIDDEN',
  PUBLISHED = 'PUBLISHED',
  PUBLISHING = 'PUBLISHING',
}

export enum NftCategory {
  ACHIEVEMENT = 'achievement',
  IDENTITY = 'identity',
}
